import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ThankYou from "@/pages/ThankYou";
const ThankYouRoute = () => <ThankYou variant="contact" />;

export const Route = createFileRoute("/en/thank-you/contact")({
  head: () => buildRouteHead("/en/thank-you/contact"),
  component: ThankYouRoute,
});

